// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2077) return "static/chunks/2077-88e1ec4d2c9c3a4d.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3070 ? "8012d7e2" : chunkId) + "." + {"1018":"7ee4cce2744e68ea","3070":"575bef338fe29d11","6233":"87230463417127b0"}[chunkId] + ".js";
};